import { createContext, useContext, useState, ReactNode } from 'react';
import type { DiscoveredPrototype, PrototypeContext } from './discoverPrototypes';

interface PrototypeNavContextValue {
  prototypes: DiscoveredPrototype[];
  context: PrototypeContext;
  commentsVisible: boolean;
  setCommentsVisible: (visible: boolean) => void;
}

const PrototypeNavContext = createContext<PrototypeNavContextValue>({
  prototypes: [],
  context: 'size2mix',
  commentsVisible: true,
  setCommentsVisible: () => {},
});

export function PrototypeNavProvider({
  prototypes,
  context,
  children,
}: {
  prototypes: DiscoveredPrototype[];
  context: PrototypeContext;
  children: ReactNode;
}) {
  const [commentsVisible, setCommentsVisible] = useState(true);
  return (
    <PrototypeNavContext.Provider value={{ prototypes, context, commentsVisible, setCommentsVisible }}>
      {children}
    </PrototypeNavContext.Provider>
  );
}

export function usePrototypeNav() {
  return useContext(PrototypeNavContext);
}
